import InputAdvancedSelect, { ShowMoreOptionValue } from 'common/components/Elements/Form/InputAdvancedSelection/InputAdvancedSelect';
import type * as I from 'core/api/coreApiClient';
import I18n from 'i18n/en-US';
import React from 'react';

const defaultOptionsShown = 1000;
const optionsPerPage = 1000;

interface ComponentProps {
  groups: I.Group[];
  filterGroup?: I.Group;
  onUpdate: (value: I.Group | undefined) => void;
}

function FilterGroupSelect({ groups, filterGroup, onUpdate }: ComponentProps) {
  const [optionsShown, setOptionsShown] = React.useState(defaultOptionsShown);
  const options = [
    { label: I18n.Elements.Table.ModalColsVisibility.FilterGroupSelect.placeholder, value: 'all' },
    ...groups.map((group) => ({ label: group.label, value: group.id })),
  ];

  return (
    <InputAdvancedSelect
      key={filterGroup?.id}
      e2eId="filterGroup"
      options={options}
      optionsShown={optionsShown}
      optionsPerPage={optionsPerPage}
      placeholder={I18n.Elements.Table.ModalColsVisibility.FilterGroupSelect.placeholder}
      values={filterGroup ? [{ label: filterGroup.label, value: filterGroup.id }] : []}
      onChange={(values) => {
        if (!values || !values[0]) return;

        if (values[0].value === ShowMoreOptionValue) {
          setOptionsShown((prevState) => prevState + optionsPerPage);
        } else if (values[0].value === 'all') {
          onUpdate(undefined);
        } else {
          onUpdate(groups.find((group) => group.id === values[0].value));
        }
      }}
    />
  );
}

export default FilterGroupSelect;
